import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";

const MobileHamburgerStyles = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  width: 50px;
  border-radius: 50%;
  background: transparent;
  align-items: center;
  justify-content: center;
  display: none;
  -webkit-tap-highlight-color: transparent;
  position: fixed;
  right: 1em;
  top: 2.6em;
  z-index: 10;

  @media ${(props) => props.theme.breakpoints.m} {
    display: flex;
  }
`;

type PathProps = {
  isOpen: boolean;
  d?: string;
  transition?: {
    duration?: number;
  };
  variants: {
    closed: {
      stroke: string;
      d?: string;
      opacity?: number;
    };
    open: {
      stroke?: string;
      d?: string;
      opacity?: number;
    };
  };
};

type MobileHamburgerProps = {
  toggle: () => void;
  isOpen: boolean;
};

const Path = (props: PathProps) => (
  <motion.path
    fill="transparent"
    strokeWidth="3"
    strokeLinecap="round"
    {...props}
  />
);

const MobileHamburger = ({ toggle, isOpen }: MobileHamburgerProps) => {
  return (
    <MobileHamburgerStyles onClick={toggle} aria-label="Mobile Hamburger">
      <svg width="23" height="23" viewBox="0 0 23 23">
        <Path
          isOpen={isOpen}
          variants={{
            closed: { stroke: "var(--color-black)", d: "M 2 2.5 L 20 2.5" },
            open: { stroke: "var(--color-white)", d: "M 3 16.5 L 17 2.5" },
          }}
        />
        <Path
          isOpen={isOpen}
          d="M 2 9.423 L 20 9.423"
          variants={{
            closed: { stroke: "var(--color-black)", opacity: 1 },
            open: { opacity: 0 },
          }}
          transition={{ duration: 0.1 }}
        />
        <Path
          isOpen={isOpen}
          variants={{
            closed: {
              stroke: "var(--color-black)",
              d: "M 2 16.346 L 20 16.346",
            },
            open: { stroke: "var(--color-white)", d: "M 3 2.5 L 17 16.346" },
          }}
        />
      </svg>
    </MobileHamburgerStyles>
  );
};

export default MobileHamburger;
